import {Address} from '@data/schema/loan-appication/address';

export class REO {
  sPropertyType: string;
  sDisposition: string;
  sOccupancy: string;
  sSubjectFlag: boolean;
  sCurrentFlag: boolean;
  sMarketValue: number;
  sMortgageLien: number;
  sMortgagePayment: number;
  sTaxExpense: number;
  sGrossRental: number;
  sOccupancyRate: number;
  sNetRentalIncome: number;
  sAddress : Address = new Address();
  sLiabilities = [];
  sLiabilityId ="";
  uiArrow = "";
  uiExpanderText="";
  uiShow =  false;
}
